export default __webpack_public_path__ + "static/media/profile_1.a6027db7.png";